var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var breathe = require('./utils/breathe');

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(interpretedArr) {
    var interpreted, i, _loop, device;

    return _regeneratorRuntime.wrap(function _callee$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            //Merge samples in interpreted obj
            interpreted = interpretedArr[0];
            i = 1;

          case 2:
            if (!(i < interpretedArr.length)) {
              _context3.next = 13;
              break;
            }

            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(device) {
              var _loop2, stream;

              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (interpreted[device]) {
                        _context2.next = 4;
                        break;
                      }

                      interpreted[device] = interpretedArr[i][device];
                      _context2.next = 11;
                      break;

                    case 4:
                      _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2(stream) {
                        return _regeneratorRuntime.wrap(function _loop2$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                if (!interpretedArr[i][device].streams[stream]) {
                                  _context.next = 4;
                                  break;
                                }

                                _context.next = 3;
                                return breathe();

                              case 3:
                                if (!interpreted[device].streams[stream]) {
                                  interpreted[device].streams[stream] = interpretedArr[i][device].streams[stream];
                                } else if (interpretedArr[i][device].streams[stream].samples) {
                                  if (!interpreted[device].streams[stream].samples) {
                                    interpreted[device].streams[stream].samples = [];
                                  }

                                  interpretedArr[i][device].streams[stream].samples.forEach(function (s) {
                                    interpreted[device].streams[stream].samples.push(s);
                                  });
                                }

                              case 4:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _loop2);
                      });
                      _context2.t0 = _regeneratorRuntime.keys(interpretedArr[i][device].streams);

                    case 6:
                      if ((_context2.t1 = _context2.t0()).done) {
                        _context2.next = 11;
                        break;
                      }

                      stream = _context2.t1.value;
                      return _context2.delegateYield(_loop2(stream), "t2", 9);

                    case 9:
                      _context2.next = 6;
                      break;

                    case 11:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop);
            });
            _context3.t0 = _regeneratorRuntime.keys(interpretedArr[i]);

          case 5:
            if ((_context3.t1 = _context3.t0()).done) {
              _context3.next = 10;
              break;
            }

            device = _context3.t1.value;
            return _context3.delegateYield(_loop(device), "t2", 8);

          case 8:
            _context3.next = 5;
            break;

          case 10:
            i++;
            _context3.next = 2;
            break;

          case 13:
            return _context3.abrupt("return", interpreted);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();